module.exports = __webpack_public_path__ + "c4f59fa345b9fcd87adf5ab52240a833.svg";